import { timeOnPage } from "./timeOnPage.es.js";
import "../../../v4-88c20f3b.js";
const analyticsTimeOnPage = () => ({
  name: "analytics-timeOnPage",
  page: ({ payload }) => {
    const pagePath = payload.properties.path;
    payload.properties = {
      ...payload.properties,
      ...timeOnPage("page", pagePath)
    };
  },
  track: ({ payload }) => {
    const pagePath = payload.properties.path || window.location.pathname;
    payload.properties = {
      ...payload.properties,
      ...timeOnPage("track", pagePath)
    };
  }
});
export {
  analyticsTimeOnPage
};
